import { Mars, NonBinary, Venus } from "lucide-react";

export const defaultDarkModeLogo = "./logos/tanalink-light.png";
export const defaultLightModeLogo = "./logos/tanalink-dark.png";

export const defaultTitle = "TLK CRM";

export const defaultOutreachStages = [
  { value: "new", label: "New" },
  { value: "contacting", label: "Contacting" },
  { value: "demo", label: "Demo" },
  { value: "qualified", label: "Qualified" },
  { value: "parked", label: "Parked" },
];

export const defaultAccountStages = [
  { value: "proposal", label: "Proposal" },
  { value: "deployment", label: "Deployment" },
  { value: "running", label: "Running" },
  { value: "review", label: "Review" },
  { value: "lost", label: "Lost" },
];

export const defaultDealStages = [
  ...defaultOutreachStages,
  ...defaultAccountStages,
];

export const defaultDealPipelineStatuses = ["running"];

export const defaultDealTypes = [
  { value: "outreach", label: "Outreach" },
  { value: "account", label: "Account" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "In Contract", color: "#a4e87d" },
];

export const defaultNoteCategories = [
  { value: "note", label: "Note" },
  { value: "email-inbound", label: "Email (Inbound)" },
  { value: "email-outbound", label: "Email (Outbound)" },
  { value: "call", label: "Call" },
  { value: "meeting", label: "Meeting" },
  { value: "presentation", label: "Presentation" },
  { value: "data-review", label: "Data Review" },
];

export const defaultPilotStages = [
  "deployment",
];

export const defaultDealCategoryColors: Record<string, string> = {
  "free-pilot": "#22c55e",
  "paid-pilot": "#3b82f6",
  "commercial": "#eab308",
};

export const defaultDealCategoryOptions = [
  { value: "free-pilot", label: "Free Pilot" },
  { value: "paid-pilot", label: "Paid Pilot" },
  { value: "commercial", label: "Commercial" },
];

export const defaultGateStages = ["qualified", "parked", "lost", "deployment"];

export const defaultTaskTypes = [
  "None",
  "Email",
  "Demo",
  "Lunch",
  "Meeting",
  "Follow-up",
  "Thank you",
  "Ship",
  "Call",
];

export const defaultContactGender = [
  { value: "male", label: "He/Him", icon: Mars },
  { value: "female", label: "She/Her", icon: Venus },
  { value: "nonbinary", label: "They/Them", icon: NonBinary },
];
